import React from "react";
import PageWrapper from "../../components/UI/PageWrapper";
import UserProfile from "../../components/Admin/UserProfile";

const UserProfilePage = () => {
  return (
    <PageWrapper>
      <UserProfile />
    </PageWrapper>
  );
};

export default UserProfilePage;
